// ===============================================================
// AdminBar — Progress bar for plan usage metrics
// ===============================================================

interface AdminBarProps {
  value: number;
  max: number;
  color?: string;
  label: string;
}

export function AdminBar({ value, max, color = '#33BCE1', label }: AdminBarProps) {
  const pct = Math.min((value / max) * 100, 100);
  const fmt = (n: number) => (n > 999 ? `${(n / 1000).toFixed(0)}K` : String(n));
  return (
    <div style={{ marginBottom: 9 }}>
      <div
        style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, marginBottom: 2 }}
      >
        <span style={{ color: '#595959' }}>{label}</span>
        <span style={{ fontWeight: 600, color: '#1F3864' }}>
          {fmt(value)}/{fmt(max)}
        </span>
      </div>
      <div style={{ height: 6, background: '#F2F2F2', borderRadius: 3, overflow: 'hidden' }}>
        <div
          style={{
            height: '100%',
            width: `${pct}%`,
            background: color,
            borderRadius: 3,
            transition: 'width 0.5s',
          }}
        />
      </div>
    </div>
  );
}
